import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M0 1h11v5H0V1zm0 7h15v5H0V8zm0 7h20v5H0v-5z'],
  height: 20,
  width: 20,
});
